import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface DeleteClaimGroupDocumentCommandArgs {
  claimGroupId: string;
  documentId: string;
}

export const deleteClaimGroupDocumentRequest = ({
  claimGroupId,
  documentId,
}: DeleteClaimGroupDocumentCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/uploads/${documentId}`,
  config: { method: SUPPORTED_METHODS.DELETE },
});

export const deleteClaimGroupDocumentCommand = async (
  args: DeleteClaimGroupDocumentCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteClaimGroupDocumentRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
